/**
 * @typedef SalaryTypes
 * @property {'fixed'} FIXED
 * @property {'mixed'} MIXED
 */

/** @type {Readonly<SalaryTypes>} */
const salaryTypes = {
  FIXED: 'fixed',
  MIXED: 'mixed',
};

module.exports = salaryTypes;
